import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  layout: {
    paddingTop: 0,
  },
  bar: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    zIndex: 100,
    position: 'sticky',
    padding: '40px 26px 10px',
    marginInline: '-26px',
    backgroundColor: 'white',
    top: '80px',
    [theme.breakpoints.down('lg')]: {
      top: '70px',
    },
    [theme.breakpoints.down('md')]: {
      top: '54px',
      padding: '40px 12px 10px',
      marginInline: '-12px',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        top: '70px',
      }),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        top: '40px',
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        top: '20px',
        padding: '40px 12px 10px',
        marginInline: '-12px',
      }),
    },
  },
  title: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        fontSize: 28,
        marginBottom: theme.spacing(2),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 22,
        marginBottom: theme.spacing(1),
      }),
    },
  },
  switcherContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(2.5),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(2.5),
      }),
    },
  },
}));
